import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { BalanceService } from 'src/app/services/balance.service';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';
import { Withdraw, WithdrawStatus } from 'src/app/types';

@Component({
  selector: 'app-with-draw-details',
  templateUrl: './with-draw-details.component.html',
  styleUrls: ['./with-draw-details.component.scss'],
})
export class WithDrawDetailsComponent implements OnInit {
  @Input() public id: any;

  withdraw?: Withdraw;

  constructor(
    private httpSv: HttpService,
    public balanceSv: BalanceService,
    private uiSv: UiServices,
    private modalController: ModalController
  ) {}

  async ngOnInit() {
    const res = await this.httpSv.itemIndex(
      'withdrawalRequest',
      '',
      {
        id: this.id,
      },
      'show'
    );
    this.withdraw = res.data;
  }

  async closeModal(reaload = false) {
    await this.modalController.dismiss(reaload);
  }

  async changeWithdrawStatus(isApproving: boolean) {
    try {
      await this.uiSv.showLoading();
      const res = await this.httpSv.itemAction(
        {
          status: isApproving
            ? WithdrawStatus.Aprobado
            : WithdrawStatus.Rechazado,
          id: this.withdraw?.id,
        },
        'withdrawalRequest',
        'update'
      );

      await this.uiSv.loading?.dismiss();
      if (res.status) {
        await this.uiSv.presentAlert(
          'Se ha realizado la operación con éxito',
          false
        );
        await this.closeModal(true);
      }
    } catch (error) {
      await this.uiSv.loading?.dismiss();
      await this.uiSv.presentAlert(error.error.data, false);
      console.error(error);
    }
  }
}
